import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
const ProductSubSubGroup = Loadable(lazy(() => import("./ProductSubSubGroup")));

const ProductSubSubGroupRoutes = [
    {
        path: '/productsubgroupone',
        element: <ProductSubSubGroup />,
    },
]

export default ProductSubSubGroupRoutes
